import { useRouter } from 'next/router';
import { useMemo } from 'react';

import Button from '~components/Button';
import Outlink from '~components/Icon/Outlink';
import useEnviromentStore from '~store/enviroment';

import * as S from './style';

interface Props {
  postId?: string;
  postCount?: number;
}

export default function ButtonMore({ postId, postCount, ...props }: Props) {
  const router = useRouter();
  const { isApp } = useEnviromentStore();
  const buttonInfo = useMemo(() => {
    if (!postCount) {
      return null;
    }

    if (postCount > 3) {
      return {
        text: `${postCount}개의 JOB담 더보기`,
        link: `/board?PK_NM_HASH=${postId}`,
      };
    }

    return {
      text: '다른 회사 JOB담 보기',
      link: '/board',
    };
  }, [postCount, postId]);

  if (!buttonInfo) {
    return null;
  }

  const handleClick = () => {
    if (isApp) {
      router.push(buttonInfo.link);
      return;
    }

    window.open(buttonInfo.link);
  };

  return (
    <Button variant='light' size='md' leading={<OutlinkIcon />} onClick={handleClick} {...props}>
      {buttonInfo.text}
    </Button>
  );
}

function OutlinkIcon() {
  return (
    <S.IconWrapper>
      <Outlink />
    </S.IconWrapper>
  );
}
